import { STORAGE_KEYS } from '../config.ts';

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
  /** Epoch-Millisekunden, ab wann das Access-Token als abgelaufen gilt. */
  expiresAt: number;
  scope: string;
}

/** Sicherheitspuffer: Token gilt 60 s vor dem echten Ablauf als abgelaufen. */
const EXPIRY_SKEW_MS = 60_000;

export function loadTokens(): StoredTokens | null {
  const raw = localStorage.getItem(STORAGE_KEYS.tokens);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredTokens>;
    if (
      typeof parsed.accessToken !== 'string' ||
      typeof parsed.refreshToken !== 'string' ||
      typeof parsed.expiresAt !== 'number'
    ) {
      return null;
    }
    return {
      accessToken: parsed.accessToken,
      refreshToken: parsed.refreshToken,
      expiresAt: parsed.expiresAt,
      scope: parsed.scope ?? '',
    };
  } catch {
    return null;
  }
}

export function saveTokens(tokens: StoredTokens): void {
  localStorage.setItem(STORAGE_KEYS.tokens, JSON.stringify(tokens));
}

export function clearTokens(): void {
  localStorage.removeItem(STORAGE_KEYS.tokens);
}

export function isExpired(tokens: StoredTokens): boolean {
  return Date.now() >= tokens.expiresAt - EXPIRY_SKEW_MS;
}

export function loadClientId(): string {
  return localStorage.getItem(STORAGE_KEYS.clientId) ?? '';
}

export function saveClientId(clientId: string): void {
  localStorage.setItem(STORAGE_KEYS.clientId, clientId.trim());
}
